import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45www_45redirect_45global from "/app/app/src/middleware/00.www-redirect.global.ts";
import _01_45initialize_45stores_45global from "/app/app/src/middleware/01.initialize-stores.global.ts";
import _02_45update_45current_45locale_45global from "/app/app/src/middleware/02.update-current-locale.global.ts";
import _03_45redirect_45global from "/app/app/src/middleware/03.redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _00_45www_45redirect_45global,
  _01_45initialize_45stores_45global,
  _02_45update_45current_45locale_45global,
  _03_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-forbidden": () => import("/app/app/src/middleware/auth-forbidden.ts"),
  "auth-required": () => import("/app/app/src/middleware/auth-required.ts"),
  "feature-required": () => import("/app/app/src/middleware/feature-required.ts"),
  "legacy-hub-category-filter": () => import("/app/app/src/middleware/legacy-hub-category-filter.ts"),
  "organization-access": () => import("/app/app/src/middleware/organization-access.ts")
}